import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { WorkspaceProvider } from './lib/workspace';
import { Shell } from './components/Shell';
import { Security } from './pages/GovernancePages';
import CryptoDashboard from './pages/CryptoDashboard';
import CryptoScanner from './pages/CryptoScanner';
import CryptoBacktesting from './pages/CryptoBacktesting';
import CryptoResearch from './pages/CryptoResearch';
import DeltaSettings from './pages/DeltaSettings';
import PaperAutomation from './pages/PaperAutomation';
import { CryptoTerminal, CryptoPortfolio, CryptoOrders, CryptoReports } from './pages/CryptoTrading';
import { CryptoStrategies, CryptoRisk, CryptoOperations, CryptoAlerts } from './pages/CryptoControls';
import './App.css';
import './pages/Crypto.css';

export default function App() {
  return <BrowserRouter><WorkspaceProvider><Shell><Routes>
    <Route path="/" element={<CryptoDashboard />} /><Route path="/terminal" element={<CryptoTerminal />} />
    <Route path="/scanner" element={<CryptoScanner />} /><Route path="/research" element={<CryptoResearch />} />
    <Route path="/strategies" element={<PaperAutomation />} /><Route path="/backtesting" element={<CryptoBacktesting />} />
    <Route path="/portfolio" element={<CryptoPortfolio />} /><Route path="/orders" element={<CryptoOrders />} />
    <Route path="/reports" element={<CryptoReports />} /><Route path="/risk" element={<CryptoRisk />} />
    <Route path="/operations" element={<CryptoOperations />} /><Route path="/alerts" element={<CryptoAlerts />} />
    <Route path="/broker" element={<DeltaSettings />} /><Route path="/security" element={<Security />} />
    <Route path="*" element={<div className="empty" data-testid="not-found">Choose a crypto workspace from navigation.</div>} />
  </Routes></Shell><Toaster theme="dark" position="bottom-right" /></WorkspaceProvider></BrowserRouter>;
}